// extracted by mini-css-extract-plugin
export default {"addressSection":"MR-z","disabled":"NR-z","sectionButtons":"OR-z","logo":"PR-z"};